import { axiosInstance } from "./apiInstance";

export const sendSlackCode = (code) => {
  return axiosInstance.post("/api/inkle/messaging/slack/oauth-success/", {
    code,
  });
};
